import React from 'react'
import { useTranslation } from 'react-i18next'
import UsersService from '../../../services/users/users.service'
import { NotificationsFuelStationService } from '../../../services/notifications-fuel-stations/notificationsFuelStations.service'
import useAccess from '../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import NotificationsCommonView from '../../../components/common/notifications-module/NotificationsCommonView'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { fuelStationsMenu } from '../../../utils/constants/navlinks-Menu'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const NotificationsFuelStations = () => {
  const { t } = useTranslation()

  const { canGet, canDelete, canAdd } = useAccess()

  return (
    <AppSection
      header={<AppTabMenu options={fuelStationsMenu} />}
      subheader={<AppToolbar leftSection={t('notification')} />}
    >
      <NotificationsCommonView
        header={<AppTabMenu options={fuelStationsMenu} />}
        canGetAccessUses={canGet(MODULES.FUELSTATIONS, GROUPS.ACCESS_USERS)}
        getUsersAccessService={UsersService.getUsersAccessFuelStation}
        getAllNotificationModules={
          NotificationsFuelStationService.getAllModulesUsers
        }
        canDeleteUser={canDelete(MODULES.FUELSTATIONS, GROUPS.NOTIFICATION)}
        removeUserNotificationModuleService={
          NotificationsFuelStationService.removeUser
        }
        canAddUser={canAdd(MODULES.FUELSTATIONS, GROUPS.NOTIFICATION)}
        addUserNotificationModuleService={
          NotificationsFuelStationService.addUser
        }
      />
    </AppSection>
  )
}

export default NotificationsFuelStations
